import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

import { SupportedLanguage } from './language.constants';
import { SKIP_BASE_URL } from '../interceptors/base-url.interceptor';

@Injectable({ providedIn: 'root' })
export class NamespacedTranslocoLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: SupportedLanguage) {
    return this.http.get<Translation>(`/i18n/${lang}.json`, {
      context: new HttpContext().set(SKIP_BASE_URL, true),
    });
  }
}
